export interface GenerateClaimTemplateInput {
    claimCategory: string;
    claimType: string;
    resellerId: string;
    preFilled?: Boolean;
    dateRange?: DateRange;
    filterMode?: PROMOTION_FILTER_MODE;
    productFamilies?: string[];
}

export interface GenerateClaimTemplateOutput {
    claimUploadTemplate: ClaimUploadTemplateDocument | null;
}

export interface ClaimUploadTemplateDocument {
    id: string;
    url: string;
    filename?: string;
    mimeType?: string;
    size?: number;
}

export type DateRange = {
    fromDate: number;
    toDate: number;
};

export enum PROMOTION_FILTER_MODE {
    ACTIVE_IN_RANGE = 'ACTIVE_IN_RANGE',
    STARTS_IN_RANGE = 'STARTS_IN_RANGE',
}

type RegionalClaimTemplateConfiguration = {
    enableRegion: boolean;
    resellerIdBlockList: string[];
    countryCodeAllowList: string[];
};

export interface FamilyMapping {
    displayName: string;
    opsFamilies: string[];
}

export const KIDS_TO_OPS_FAMILY_MAPPING: Record<string, FamilyMapping> = {
    Accessory: { displayName: 'Accessory', opsFamilies: ['Accessory'] },
    AuCC: { displayName: 'AuCC', opsFamilies: ['AuCC'] },
    Blink: { displayName: 'Blink', opsFamilies: ['BLINK'] },
    CoRo: { displayName: 'CoRo', opsFamilies: ['CORO'] },
    'Dash Button': { displayName: 'Dash Button', opsFamilies: ['Dash Button'] },
    SMP: { displayName: 'SMP', opsFamilies: ['Companion_devices', 'SMP'] },
    'E-Ink': { displayName: 'E-Ink', opsFamilies: ['E-Ink'] },
    eero: { displayName: 'Eero', opsFamilies: ['EERO'] },
    'FireTV 1P Screens': { displayName: 'FireTV', opsFamilies: ['FTV_TV'] },
    Ring: { displayName: 'Ring', opsFamilies: ['Ring Devices', 'Ring_Smart_Lighting'] },
    Tablet: {
        displayName: 'Tablet',
        opsFamilies: ['Tablet', 'Sanibel MFA Stylus', 'Sanibel MFA Stylus for Fire Max 11'],
    },
    'Smart Home': { displayName: 'Smart Home', opsFamilies: ['Smart Home'] },
    Health: { displayName: 'Echo Frames', opsFamilies: ['ZEPHYR'] },
};

export const OPS_COUNTRY_TO_REGION = {
    US: 'NA',
    CA: 'NA',
    CO: 'NA',
    MX: 'NA',
    PE: 'NA',

    DE: 'EU',
    GB: 'EU',
    FR: 'EU',
    IT: 'EU',
    ES: 'EU',
    NL: 'EU',
    AE: 'EU',
    SA: 'EU',

    AU: 'ANZ',
    NZ: 'ANZ',

    BR: 'BR',
};

type RegionalClaimTemplateConfigurationsMap = Record<'NA' | 'EU' | 'ANZ' | 'BR', RegionalClaimTemplateConfiguration>;

export const OPS_REGIONAL_CLAIM_TEMPLATE_CONFIG_MAP: RegionalClaimTemplateConfigurationsMap = {
    NA: {
        enableRegion: true,
        resellerIdBlockList: [],
        countryCodeAllowList: ['US', 'CA'],
    },
    EU: {
        enableRegion: true,
        resellerIdBlockList: [],
        countryCodeAllowList: ['DE', 'FR', 'IT', 'ES', 'GB', 'AE', 'SA', 'NL'],
    },
    ANZ: {
        enableRegion: true,
        resellerIdBlockList: [],
        countryCodeAllowList: ['AU', 'NZ'],
    },
    BR: {
        enableRegion: true,
        resellerIdBlockList: [],
        countryCodeAllowList: ['BR'],
    },
};
